module.exports = __webpack_public_path__ + "static/madonnaChild-ea42ab06ed168db54cbbae016cd01262.jpg";